import { Divider, Grid, Tooltip } from '@material-ui/core';
import { useState } from 'react';
import { SectionTitle, SubSectionTitle, useCompanyFormState } from '../common';
import * as userService from 'services/user';
import { blue, lime } from '@material-ui/core/colors';
import ContactMailRoundedIcon from '@material-ui/icons/ContactMailRounded';
import PersonPinCircleRoundedIcon from '@material-ui/icons/PersonPinCircleRounded';
import { CompanyBasicFormField, HQLocationField, OtherOfficesField } from '../fields';
import { useFormContext } from 'react-hook-form';
import { HelperTextTip } from '@components/hepler-text-tip';
import Fab from '@material-ui/core/Fab';
import styled from 'styled-components';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockClosedIcon from '@material-ui/icons/Lock';
import { VerifiedDetails } from './section-utils';

export const SectionContact = () => {
  const { control } = useFormContext();
  const form = useFormContext();
  const { edit, company } = useCompanyFormState();
  const { user } = userService.useUser();
  const [isLock, setLock] = useState<boolean>(
    (company &&
      company.verified_sections &&
      company.verified_sections.contact_section &&
      company.verified_sections.contact_section.verified) ||
      edit
  );
  const watchOnVerifiedSections = form.watch('verified_sections');
  const verifiedBy =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.contact_section &&
    watchOnVerifiedSections.contact_section.verified_by;
  const verifiedAt =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.contact_section &&
    watchOnVerifiedSections.contact_section.verified_at + ' IST';
  return (
    <>
      <Grid container spacing={2} justify="space-between">
        <Grid item>
          <SectionTitle
            title="Contact Details"
            id="contact-info"
            subTitle="Key contact information"
            icon={<ContactMailRoundedIcon style={{ color: lime[700] }} fontSize="large" />}
          />
        </Grid>
        <Grid item style={{ paddingBottom: '10px' }}>
          <Tooltip
            title={
              isLock ? (
                <>
                  {`Verified by ${verifiedBy}`}
                  <br />
                  {`Verified at ${verifiedAt}`}
                </>
              ) : (
                'Click to Lock the Section'
              )
            }>
            {isLock ? (
              <StyledFab
                color="primary"
                style={{ backgroundColor: 'green' }}
                aria-label="add"
                size="small"
                onClick={() => {
                  setLock(false);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    contact_section: { verified: false, verified_by: null, verified_at: null,isLockApplied: false },
                  });
                }}>
                <LockClosedIcon />
              </StyledFab>
            ) : (
              <StyledFab
                color="primary"
                style={{ backgroundColor: 'red' }}
                aria-label="add"
                size="small"
                onClick={() => {
                  setLock(true);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    contact_section: {
                      verified: true,
                      verified_by: user.vtr_id,
                      verified_at: new Date().toLocaleString('en-US', { timeZone: 'IST' }),
                      isLockApplied: true,
                    },
                  });
                  // company.verified_sections.contact_section.verified_by = user.vtr_id;
                  // company.verified_sections.contact_section.verified = true;
                }}>
                <LockOpenIcon />
              </StyledFab>
            )}
          </Tooltip>
          {isLock && <VerifiedDetails verifiedBy={verifiedBy} verifiedAt={verifiedAt} />}
        </Grid>
      </Grid>

      <Divider />
      <br />
      <div>
      <fieldset disabled={isLock && edit} style={{"border":"none"}}>
        <Grid container spacing={3} alignItems="center">
          
          <Grid item xs={4}>
            <HQLocationField control={control} name="hqLocation" />
          </Grid>
          <Grid item xs>
            <CompanyBasicFormField
              name="email"
              type="email"
              label="Email ID"
              helperText={
                <HelperTextTip
                  text="Official Email address of the company"
                  tip="[Tip: No hashtags, social media handles]"
                />
              }
            />
            <br />
            <br />
            <CompanyBasicFormField
              name="hqaddress"
              label="Headquarter Address"
              multiline
              helperText="Complete address of the Headquarters of the Company"
              rowsMax={4}
              rows={4}
            />
          </Grid>
          
        </Grid>
        </fieldset>
        <br />
        <SubSectionTitle
          title="Other Offices"
          subTitle="Locations of other offices of the Company"
          icon={<PersonPinCircleRoundedIcon fontSize="large" style={{ color: blue[800] }} />}
        />
        <Divider />
        <br />
        <OtherOfficesField control={control} name="otherOffices" />
        {/* <OtherOffices value={location} onChange={setLoction} /> */}
      </div>
    </>
  );
};

const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;
